<template>
    <div class="page">
        <form class="form">
            <label class="form__label">{{ $t("PLEASE_ENTER_YOUR_EMAIL") }}:</label>
            <div class="form__group g-code">
                <input
                    v-model="email"
                    placeholder="user@example.com"
                    type="email"
                    class="g-code__input"
                />
                <button
                    type="submit"
                    class="g-code__button"
                    :class="{ 'g-code__button_loading': this.isLoadingCode }"
                    @click.prevent="getCode"
                >
                    <span class="g-code__loader"></span>
                    <img class="g-code__icon" src="@/assets/icon-device.svg" />
                    {{ $t("LINK_YOUR_APPLE_TV") }}
                </button>
            </div>
            <br/>
            <p style="color: orange; text-align: center">{{ $t("DO_NOT_USE_HOSTILE_EMAILS") }}</p>
        </form>

        <div v-if="code" class="instructions">
            <h2 class="instructions__heading">{{ $t("TO_LINK_APPLE_TV") }}</h2>
            <ul
                class="instructions__list"
                v-html="
                    $t('LINK_APPLE_TV_STEPS', {
                        link: `https://a.appdb.to/add/?${code}`,
                    })
                "
            ></ul>

            <v-button
                class="instructions__submit-button"
                type="primary"
                :loading="isLinking"
                @click.native="link"
            >
                {{ $t('I_INSTALLED_PROFILE') }}
            </v-button>
        </div>
    </div>
</template>

<script>
import VButton from '@/components/Button.vue';

export default {
  components: {
    VButton,
  },
  data() {
    return {
      email: '',
      isLoadingCode: false,
      isLinking: false,
      code: '',
    };
  },
  computed: {
    title() {
      return this.$t('LINK_YOUR_APPLE_TV');
    },
  },
  methods: {
    async getCode() {
      this.isLoadingCode = true;
      try {
        this.code = await this.$api.getTVLinkCode({ email: this.email });
      } finally {
        this.isLoadingCode = false;
      }
    },
    async link() {
      this.isLinking = true;
      try {
        const data = await this.$api.link({ email: this.email, code: this.code, type: 'control' }, true);
        this.$store.commit('lt', data.link_token);
        await Promise.all([this.$store.dispatch('getCustomerProfile'), this.$store.dispatch('getConfig'), this.$store.dispatch('getDevices')]);
        this.$notify({
          type: 'success',
          text: this.$t('APPLE_TV_WAS_LINKED'),
        });
        this.$router.push('/my/devices');
      } finally {
        this.isLinking = false;
      }
    },
  },
  beforeCreate() {
    if (this.$store.getters.isDeviceLinked) {
      this.$router.push('/my/devices');
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.page {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
}

.form {
  background: var(--bg);
  border: 1px solid #ebebeb;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @include notebook {
    margin: 10px 0 10px;
    text-align: center;
  }

  &__group {
    margin-top: 10px;
    width: 100%;
    max-width: 410px;
  }
}

.instructions {
    margin-top: 20px;
    background: var(--secondary-bg);
    border-radius: 8px;
    padding: 10px;
    margin: 15px auto 0;
    width: fit-content;
    max-width: 100%;

    &__heading {
        font-weight: 500;
        margin-bottom: 5px;
    }

    &__list {
        list-style: decimal inside;
        text-align: left;

        &::v-deep {
            li {
                margin-bottom: 3px;
                line-height: 18px;
            }

            strong {
                font-weight: bold;
            }
        }
    }

    &__submit-button {
        display: block;
        width: fit-content;
        margin: 10px auto 0;
    }
}
</style>
